
<section class="block mx-auto mt-32 max-w-448">
  <SitterAlertBanner v-if="serverError" :error="serverError" />
  <PoppinsCard>
    <CareTypeFormHeader careType="housekeeping" />
    <form id="create-profile-housekeeping" novalidate @submit.prevent="handleSubmit">
      <div v-for="(field, index) in formFields" :key="index">
        <component :is="field.component" ref="childComponents" v-bind="field.props" />
      </div>

      <PoppinsButton
        id="formSubmit"
        :loading="loading"
        class="w-full my-8"
        variant="primary"
        value="Save & Continue"
        size="medium"
        type="submit"
      />
    </form>
  </PoppinsCard>
</section>
